import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { getEtfScreener } from "./etf-screener.api";
import type { EtfScreenerQuery, EtfScreenerResponse } from "./etf-screener.type";

export const etfScreenerKeys = {
  all: ["etf-screener"] as const,
  list: (query: EtfScreenerQuery) => [...etfScreenerKeys.all, query] as const,
};

export const useEtfScreener = (
  query: EtfScreenerQuery,
  options?: Omit<UseQueryOptions<EtfScreenerResponse, Error>, "queryKey" | "queryFn">,
) =>
  useQuery({
    queryKey: etfScreenerKeys.list(query),
    queryFn: ({ signal }) => getEtfScreener(query, { signal }),
    staleTime: 60_000,
    ...options,
  });
